import CryptoJS from 'crypto-js';

const SECRET_KEY = 'BAG_v#DbA3&l:<0eYs}2dICN_/3d1QOY'; // 🚨 Cseréld le egy erősebb kulcsra! 🚨 NxXJ4JDNyGouaQvKpTL2GUjsiQ3ks5kb

export const encryptData = (data: string) => {
  return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
};

export const decryptData = (ciphertext: string) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption failed:', error);
    return ''; // Ha nem sikerül visszafejteni, üres stringet ad vissza
  }
};
